import { Fragment, useImperativeHandle, useState } from 'react';

import NovaDialog from '@/components/dialog';
import { UserResourceType } from '@/interface/library';
import { ISpineResult } from '@/material/form-upload/folder';

import Library from '..';
import styles from './index.module.less';

export interface ILibraryDialogRef {
  close: () => void;
  open: () => void;
}

export interface ILibraryDialog {
  dialogRef?: React.ForwardedRef<ILibraryDialogRef>;
  type?: UserResourceType;
  confirmCallback?: (checkValue: {
    url: string;
    name: string;
  } | ISpineResult) => void;
  closeCallback?: () => void;
}

function LibraryDialog(props: ILibraryDialog) {
  const { dialogRef, closeCallback } = props;

  useImperativeHandle(dialogRef, () => ({
    close,
    open,
  }));

  const [visible, setVisible] = useState(false);

  const close = () => {
    closeCallback?.();
    setVisible(false);
  };

  const open = () => {
    setVisible(true);
  };

  return (
    <Fragment>
      <NovaDialog
        dialogConfig={{
          visible,
          closeBtn: false,
          cancelBtn: null,
          header: null,
          footer: null,
          className: styles.dialogContent,
          style: {
            padding: 0,
            height: '80vh',
            overflow: 'hidden',
          },
        }}
      >
        {visible && <Library {...props} close={close} open={opener} visible={visible} />}
      </NovaDialog>
    </Fragment>
  );
}

export default LibraryDialog;
